// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__AuQA-","title":"ClientReferral_title__3Tdwf","itemText":"ClientReferral_itemText__2HAZJ"};